module.exports = __webpack_public_path__ + "static/media/21ECLAC16.ab8493f5.jpg";